module.exports = __webpack_public_path__ + "img/dribble-logo.3befec21.svg";